import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation(['common', 'navigation', 'products']);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#3A312A] text-[#F6F1EA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-serif font-bold mb-4 text-white">MIELA MAISON</h3>
            <p className="text-[#E8DDD0] text-sm leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a
                href="mailto:contact@mielamaison.com"
                className="text-[#B08D57] hover:text-white transition-colors duration-300"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#E8DDD0] hover:text-[#B08D57] transition-colors duration-300 text-sm">
                  {t('common.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#E8DDD0] hover:text-[#B08D57] transition-colors duration-300 text-sm">
                  {t('common.about')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-[#E8DDD0] hover:text-[#B08D57] transition-colors duration-300 text-sm">
                  {t('common.products')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#E8DDD0] hover:text-[#B08D57] transition-colors duration-300 text-sm">
                  {t('common.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">{t('footer.ourProducts')}</h4>
            <ul className="space-y-3">
              <li className="text-[#E8DDD0] text-sm">{t('products:categories.coffee.name')}</li>
              <li className="text-[#E8DDD0] text-sm">{t('products:categories.honey.name')}</li>
              <li className="text-[#E8DDD0] text-sm">{t('products:categories.whisky.name')}</li>
              <li className="text-[#E8DDD0] text-sm">{t('products:categories.tea.name')}</li>
              <li className="text-[#E8DDD0] text-sm">{t('products:categories.cosmetics.name')}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">{t('footer.contactUs')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-[#B08D57] mt-1 flex-shrink-0" />
                <a href="mailto:contact@mielamaison.com" className="text-[#E8DDD0] hover:text-[#B08D57] transition-colors duration-300 text-sm">
                  contact@mielamaison.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#B08D57] mt-1 flex-shrink-0" />
                <span className="text-[#E8DDD0] text-sm">Osaka, Japan</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E1B18] mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#E8DDD0] text-sm">
              © {currentYear} Miela Maison. {t('footer.allRightsReserved')}.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-[#E8DDD0] hover:text-[#B08D57] transition-colors duration-300 text-sm">
                {t('footer.privacyPolicy')}
              </a>
              <a href="#" className="text-[#E8DDD0] hover:text-[#B08D57] transition-colors duration-300 text-sm">
                {t('footer.termsOfService')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};